export const TABLEAU_URL = 'https://backmarket.mydral.com'

export const TABLEAU_SRC = `${TABLEAU_URL}/javascripts/api/tableau-2.min.js`
